import React from 'react';
import ReactDOM from 'react-dom';
import IngredientsOverview from './IngredientsOverview';
import Slider from './Slider';
import LandscapesMenu from './LandscapesMenu';
import LandscapesMenuMobile from './LandscapesMenuMobile';

import EventsOverview from './EventsOverview';
import FromPoly from './ArrayFromPolyFill'

var slider = document.getElementById('react-root-slider')
if (slider) {
  ReactDOM.render(
    <Slider />,
    slider
  );
}

var ingredients = document.getElementById('ingredients-overview-root')
if (ingredients) {
  ReactDOM.render(
    <IngredientsOverview />,
    ingredients
  );
}




var eventsOverview = document.getElementById('events-overview')
if (eventsOverview) {
  ReactDOM.render(
    <EventsOverview />,
    eventsOverview
  );
}

var landscapesMenu = document.getElementById('landscapes-menu')
if (landscapesMenu) {
  ReactDOM.render(
    <LandscapesMenu />,
    landscapesMenu
  );
}
var landscapesMenuMobile = document.getElementById('landscapes-menu-mobile')
if (landscapesMenuMobile) {
  ReactDOM.render(
    <LandscapesMenuMobile />,
    landscapesMenuMobile
  );
}



// WEBPACK FOOTER //
// ./src/index.js